export function localStorageGet(key: string) {
  try {
    const item = localStorage.getItem(key);
    return JSON.parse(item);
  } catch (error) {
    console.log(error);
    return null;
  }
}

export function localStorageSet(key: string, value: any) {
  try {
    const string = JSON.stringify(value);
    localStorage.setItem(key, string);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
}
